module.exports = __webpack_public_path__ + "static/media/key.b6870872.svg";